import * as Yup from 'yup';
import { countryCodes } from '@/helpers/countries';

export default Yup.object({
  firstname: Yup.string()
    .required('Debe escribir su nombre')
    .matches(/^[a-zA-Z0-9À-ú ]+$/i, 'Solo se permiten valores alfanuméricos'),
  lastname: Yup.string()
    .required('Debe escribir sus apellidos')
    .matches(/^[a-zA-Z0-9À-ú ]+$/i, 'Solo se permiten valores alfanuméricos'),
  email: Yup.string()
    .required('Debe escribir su correo electrónico')
    .email('Debe escribir un correo electrónico válido'),
  country: Yup.string()
    .required('Debe seleccionar un país')
    .oneOf(countryCodes(), 'Solo se permite un código de dos letras válido'),
  phone: Yup.string()
    .required('Este campo es requerido')
    .matches(/^(?=.*[0-9])[+()0-9 ]+$/i, 'Solo se permiten números de teléfonos válidos'),
});
